import { useMutation, gql } from '@apollo/client'
import * as React from 'react'
import styled from 'styled-components'
import Balloon from 'components/Icon/Post/Balloon'
import Heart from 'components/Icon/Post/Heart'
import HeartFill from 'components/Icon/Post/HeartFill'
import Locked from 'components/Icon/Post/Locked'
import { Icon, IconButton } from '@material-ui/core'
import { useCurrentUser } from 'utils/context/UserContext'
import { Router } from 'routes'

export default function ActionFooter({ post }) {
  const [likePost, { loading }] = useMutation(LIKE_POST)
  const { currentUser } = useCurrentUser()

  return (
    <Actions>
      <div style={{ flex: '1 1 auto' }}>
        <IconButton disabled>
          <Icon>{post.isPremium && <Locked />}</Icon>
        </IconButton>
      </div>
      <div>
        <IconButton disabled>
          <Balloon />
        </IconButton>
        <Count>{post.replyCount}</Count>
      </div>
      <div>
        {post.isLike || loading ? (
          <IconButton disabled>
            <HeartFill />
          </IconButton>
        ) : (
          <IconButton
            onClick={e => {
              if (!currentUser) return Router.pushRoute('login')

              e.stopPropagation()
              likePost({ variables: { postId: post.id } })
            }}
          >
            <Heart />
          </IconButton>
        )}
        <Count>{loading ? post.likeCount + 1 : post.likeCount}</Count>
      </div>
    </Actions>
  )
}

const Count = styled.span({
  padding: '0 5px 0 0',
})

const Actions = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: 10,
})

const LIKE_POST = gql`
  mutation($postId: ID!) {
    likePost(postId: $postId) {
      id
      likeCount
      isLike
    }
  }
`
